import { API_PATHS } from "../../config/ApiPaths";

export const apiRevenueHalotel = (stateDate, endDate) => {
  return `${API_PATHS.halotelRevenue}?startDate=${stateDate}&endDate=${endDate}`;
};
